export const getMemberAppreciation = (creationTime) => {
  if (!creationTime) return { accent: "border-gray-200", memberSince: null };

  const joinDate = new Date(creationTime);
  const now = new Date();
  const months =
    (now.getFullYear() - joinDate.getFullYear()) * 12 +
    (now.getMonth() - joinDate.getMonth());

  const memberSince = joinDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
  });

  if (months >= 12) return { accent: "border-purple-300", memberSince };
  if (months >= 6) return { accent: "border-blue-300", memberSince };
  if (months >= 3) return { accent: "border-green-300", memberSince };
  return { accent: "border-gray-200", memberSince };
};
